import {metadaApi} from '@dms/api/base';

import {
  GetSupplierPriceListItemRequest,
  GetSupplierPriceListItemRequestSchema,
  GetSupplierPriceListItemResponse,
  GetSupplierPriceListItemResponseSchema,
} from './types';

export const metadaWarehouseSupplierPriceListItemApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Reads a single supplier price list item from the search engine. Modelled as a query
     * (not a mutation) because it only reads data — the endpoint is POST solely because the
     * search criteria are sent in the body.
     */
    getSupplierPriceListItem: build.query<
      GetSupplierPriceListItemResponse,
      GetSupplierPriceListItemRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/supplier-price-list-item`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        requestSchema: GetSupplierPriceListItemRequestSchema,
        responseSchema: GetSupplierPriceListItemResponseSchema,
      },
    }),
  }),
});

export const {useGetSupplierPriceListItemQuery} = metadaWarehouseSupplierPriceListItemApi;
